import Vue from 'vue'
import Vuex from 'vuex'
import {Coleccion_trabajadores} from '@/FirebaseConfig'
import {cleanObject, secondsToFullTimestamp} from '@/Helper.js'  
Vue.use(Vuex)
export default {
    namespaced:true,
      state: {
        datos:{
            nombre:'',
            direccion:'',
            telefono:'',
            email:'',
            createdAt:'',
            documento: '',
        },
        registro:{},
        selectedKey: '',
        dialog: false,
      },
      mutations: {
        getAllItems(state, item) {
          Vue.set( state.registro, item.id, {...item.data(), createdAt: secondsToFullTimestamp(item.data().createdAt)} )
        },
        clean(state,key){
          Vue.delete(state.registro,key)
        }
      },
      actions: {
        
        getAll:(context)=>{
          context.state.registro = {}
          Coleccion_trabajadores.get().then(datos=>datos.docs.map( item => context.commit( 'getAllItems', item  ) ) )
        },
        add:context=>{
          
          if(context.state.selectedKey==''){
            Coleccion_trabajadores.add({...context.state.datos, createdAt:new Date}).then(()=>{
              context.commit('Helpers/launchSnackbar', 'Se ha registrado un nuevo trabajadore', { root: true })
              cleanObject(context.state.datos)
              context.state.dialog = false
            })
          }else{
            Coleccion_trabajadores.doc(context.state.selectedKey).update(context.state.datos).then(()=>{
              context.commit('Helpers/launchSnackbar', ' Ha sido modificado correctamente', { root: true })
              cleanObject(context.state.datos)
              context.state.dialog = false
            })
          }
        },
        clean:(context, key)=>{
            Coleccion_trabajadores.doc(key).delete().then(()=>{
            context.commit('Helpers/launchSnackbar', ' Ha sido eliminado', { root: true })            
            context.commit('clean',key)})
        },
        get:(context, key)=>{
            Coleccion_trabajadores.doc(key).get().then(doc=>{
            context.state.datos = doc.data()
            context.state.selectedKey = key
            context.state.dialog = true
          })
        },
        clearForm:(context)=>{
          context.state.dialog = false
          context.state.selectedKey = ''
          context.state.datos = {
            nombre:'',
            direccion:'',
            telefono:'',
            email:'',
            createdAt:'',
            documento: '',
          }
        },
      },
      getters: {
        registro: state => Object.keys(state.registro).map(item => ({...state.registro[item], key: item }) ),
      },
  }
  